<template>
  <div>
    <stripe-element-payment
      v-if="clientSecret !== null"
      ref="paymentRef"
      :pk="pk"
      :elements-options="elementsOptions"

      :confirm-params="confirmParams"
    />
    <button
    v-if="clientSecret !== null"
      class="btn btn-primary btnStripe px-5 py-3 w-100 fw-bold"
      @click="pay"
    >
    <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Pagar con Stripe
    </button>

    <p v-if="clientSecret !== null">
        Tu orden ser&aacute; enviada una vez que tu pago sea confirmado.
    </p>
  </div>
</template>
  
  <script>
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
const axios = require("axios");
export default {
  components: {
    StripeElementPayment,
  },
  props: ["showForm", "addressData", "products", "codeCoupon"],
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
      pk: process.env.VUE_APP_STRIPE,
      elementsOptions: {
        appearance: {
            theme:'flat',
        }, // appearance options
      },
      confirmParams: {
        return_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE + "ThankYouPage" ,
        // return_url:  "http://localhost:8080/ThankYouPage" ,
      },
      userId: null,
      address: null,
      addressId: null,
      clientSecret: null,
      loader:false,
    };
  },
  created() {
    this.userId = $cookies.get("uidmmkg");
    this.address = this.addressData;
    this.addressId = this.addressData.id;
    console.log(parseInt(this.userId));
    console.log(this.address);
    console.log(this.addressId);
    console.log(this.products);
    console.log(this.codeCoupon);
  },
  watch: {
    clientSecret(newVal, oldVal){
        this.elementsOptions.clientSecret = newVal;
    },
    showForm(newVal, oldVal){
        console.log("is_stripe: ",newVal);
        if(newVal){
            this.generatePaymentIntent()
        }
    }
  },
  methods: {
    async generatePaymentIntent() {
      console.log("intento de pago");
      axios({
        method: "POST",
        url: this.api_url + "/payment/stripe",
        data: {
          user_id: this.userId,
          address: this.address,
          address_id: this.addressId,
          return_url: this.local_url + "/success",
          // return_url: "http://localhost:8080/success",
          code: this.codeCoupon,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((res) => {
          console.info("Stripe(Intento de pago)");
          console.info(res.data);
          if (res.data.status) {
            this.clientSecret =  res.data.secret_client;
            this.$emit('statusLoading', false)
          } else {
            this.$snotify.error(res.data.message);
            this.$emit('statusLoading', false)
          }
        })
        .catch((error) => {
          this.$snotify.error(error);
          console.error(error);
          this.$emit('statusLoading', false)
        });
    },
    pay () {
      try {
        this.loader = true;
        console.log("pagando...");
        this.$refs.paymentRef.submit();
        localStorage.setItem('temporalProducts', JSON.stringify(this.products));
        localStorage.setItem('metodoPago', "stripe");
      } catch (error) {
        this.$snotify.error(error);
      }
      setTimeout(() => {
        this.loader = false;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.btnStripe{
    background-color:#33325d !important;
    font-weight: 900;
}
.btnStripe:hover{
    background-color:#33325d !important;
    font-weight: 900;
}
#stripe-payment-element-errors{
    margin:50px 0 !important; 
}

</style>